import React, { useState, useRef, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import "./refer.css";
import { endPoints } from "../../../constant/Environment";
import Loader from "../../../components/Loader";
import { getAllData } from "../../../Utility/API";

const ReferFriendHistory = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [referList, setReferList] = useState([]);

  const fetchReferData = () => {
    let url = `${endPoints.api.REFER_USERS}/${userId}`;
    setIsLoading(true);
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        setIsLoading(false);
        if (status === "success") {
          setReferList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //betplaced added

  useEffect(() => {
    fetchReferData();
  }, []);
  const renderStatus = (data) => {
    const steps = ["Signup","KYC", "Bet"];
    const validStatus = [
      data.isSingup == 1, // Tick if isSignup is 1
      data.validation == 1, // Tick if validation is 1
      data?.betPlaced == 1, // Tick if IsbetPlaced is 1
    ];

    return (
      <div className="status-stepper">
        {steps.map((step, index) => (
          <div key={index} className="step">
            {/* Circle for each step */}
            <div className={`circle ${validStatus[index] ? "completed" : ""}`}>
              {validStatus[index] && "✔"}
            </div>
            {/* Conditional connector line: only if the current and next steps are both ticked */}
            {index < steps.length - 1 &&
              validStatus[index] &&
              validStatus[index + 1] && <div className="step-connector"></div>}
            {/* step labels */}
            <span className="step-label">{step}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div className="col-md-12">
        <div className="custom-table-data mt-4">
          <div style={{ display: "flex" }}>
            <h4 className="dark-gray f-bold mb-4" style={{ marginTop: "14px" }}>
              Refer Friend List{" "}
            </h4>
          </div>

          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">User Id </TableCell>
                  <TableCell align="center">Name </TableCell>

                  <TableCell align="center">Email </TableCell>
                  <TableCell align="center"> Bouns Amount</TableCell>
                  <TableCell align="center"> Status </TableCell>

                  <TableCell align="center"> Bonus Status </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {referList?.length > 0 &&
                  referList.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell align="center">{row?.userId}</TableCell>
                      <TableCell align="center">{row?.name}</TableCell>

                      <TableCell align="center">{row?.email}</TableCell>
                      <TableCell align="center">{row?.referamount}</TableCell>

                      <TableCell align="center">{renderStatus(row)}</TableCell>

                      <TableCell align="center">{row?.referStatus}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default ReferFriendHistory;
